import { createContext } from 'react';
import type { useSolanaWallets } from '../hooks/useSolanaWallets';

export type WalletAccountContextValue = ReturnType<typeof useSolanaWallets>;

export const WalletAccountContext = createContext<WalletAccountContextValue | null>(null);
